import React, {useState, useEffect, useRef} from 'react';
import firebase from "firebase/app";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import {useHistory} from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import SensorValueCell from './SensorValueCell';

const array=[];

const CentralDashboard = () => {
    const [room4, setroom4] = useState([]);
    const history = useHistory();
    const [details, setDetails] = useState([]);
    const [loading, setLoading] =useState(true);

    const rowClickHandler = (rowData, rowMeta) =>{
      history.push(`/hospitals/${rowData[1].toLowerCase()}/${rowData[2].toLowerCase()}`);
    }

    const rtd = firebase.database().ref('/Hospitals');

    const columns = [{
        name:"name",
        label:"Name",
     },
     {
        name:"hospitalName",
        label:"Hospital Name",
     },
     {
      name:"roomNo",
      label:"Room",
    },
     {
         name:"mq2",
         label:"Mq2",
         options:{
          customBodyRender: (value, tableMeta, updateValue)=>(
            <SensorValueCell value={value} tableMeta={tableMeta} updateValue={updateValue}/>
          )
        }
     },
     {
        name:"mq9",
        label:"Mq9",
        options:{
          customBodyRender: (value, tableMeta, updateValue)=>(
            <SensorValueCell value={value} tableMeta={tableMeta} updateValue={updateValue}/>
          )
        }
    },
    {
        name:"mq135",
        label:"Mq135",
        options:{
          customBodyRender: (value, tableMeta, updateValue)=>(
            <SensorValueCell value={value} tableMeta={tableMeta} updateValue={updateValue}/>
          )
        }
    },
    {
        name:"temp",
        label:"Temp",
        options:{
          customBodyRender: (value, tableMeta, updateValue)=>(
            <SensorValueCell value={value} tableMeta={tableMeta} updateValue={updateValue}/>
          )
        }
    },
    {
        name:"humid",
        label:"Humid",
        options:{
          customBodyRender: (value, tableMeta, updateValue)=>(
            <SensorValueCell value={value} tableMeta={tableMeta} updateValue={updateValue}/>
          )
        }
    },
    {
        name:"bloodOxygen",
        label:"Blood Oxygen",
        options:{
          customBodyRender: (value, tableMeta, updateValue)=>(
            <SensorValueCell value={value} tableMeta={tableMeta} updateValue={updateValue}/>
          )
        }
    },     
    {
        name:"bloodPressureSystolic",
        label:"Blood Pressure Systolic",
        options:{
          customBodyRender: (value, tableMeta, updateValue)=>(
            <SensorValueCell value={value} tableMeta={tableMeta} updateValue={updateValue}/>
          )
        }
    },
    {
        name:"bloodPressureDiastolic",
        label:"Blood Pressure Diastolic",
        options:{
          customBodyRender: (value, tableMeta, updateValue)=>(
            <SensorValueCell value={value} tableMeta={tableMeta} updateValue={updateValue}/>
          )
        }
    },
    {
        name:"bodyTemperature",
        label:"Body Temp",
        options:{
          customBodyRender: (value, tableMeta, updateValue)=>(
            <SensorValueCell value={value} tableMeta={tableMeta} updateValue={updateValue}/>
          )
        }
    },
    {
        name:"heartRate",
        label:"Heart Rate",
        options:{
          customBodyRender: (value, tableMeta, updateValue)=>(
            <SensorValueCell value={value} tableMeta={tableMeta} updateValue={updateValue}/>
          )
        }
    }];

    const options = {
      selectableRows:"none",
      onRowClick:rowClickHandler,
      responsive:"standard",
    };

    useEffect(()=>{
      firebase.database().ref('Hospitals/Hospital-2/Rooms/Room-4').on("value", (snapshot)=>{
        const room4CentralValues = []
        const room4Data = snapshot.val()
        const room4String = "Room-4"
        room4CentralValues.push({room4String, room4Data})
        // snapshot.val()[Object.keys(snapshot.val())[Object.keys(snapshot.val()).length - 1]]?.value
        console.log(room4CentralValues)
        setroom4(room4CentralValues);
        console.log(room4)
      }) 
      rtd.on("value", (snapshot)=>{
        const array = [];
        console.log("Triggered");
        snapshot.forEach(hospital=>{
          Object.values(hospital.val().Rooms)
          .forEach((patientRoom, roomIndex)=>{
            // if(hospitalName=="Hospital-1"){
            //   if(patientRoom == "Room-1"){
            //     patientRoom = "Room-4"
            //   }
            // }
            const hospitalName = hospital.key;
            const mq2 = (Object.keys(patientRoom.sensorData.room.mq2).length-1>0 
            ? Object.values(patientRoom.sensorData.room.mq2)[(Object.keys(patientRoom.sensorData.room.mq2).length-1)].value
            // : Object.keys(patientRoom.sensorData.room.mq2).length-1>0 
            // ? Object.values(patientRoom.sensorData.room.mq2)[0].value   
            : patientRoom.sensorData.room.mq2).toFixed(1);
            const mq9 = (Object.keys(patientRoom.sensorData.room.mq9).length-1>0 ? Object.values(patientRoom.sensorData.room.mq9)[(Object.keys(patientRoom.sensorData.room.mq9).length-1)].value : patientRoom.sensorData.room.mq9).toFixed(1);
            const mq135 = (Object.keys(patientRoom.sensorData.room.mq135).length-1>0 ? Object.values(patientRoom.sensorData.room.mq135)[(Object.keys(patientRoom.sensorData.room.mq2).length-1)].value : patientRoom.sensorData.room.mq135).toFixed(1);
            const temp = (Object.keys(patientRoom.sensorData.room.temp).length-1>0 ? Object.values(patientRoom.sensorData.room.temp)[(Object.keys(patientRoom.sensorData.room.temp).length-1)].value : patientRoom.sensorData.room.temp).toFixed(1);
            const humid = (Object.keys(patientRoom.sensorData.room.humid).length-1>0 ? Object.values(patientRoom.sensorData.room.humid)[(Object.keys(patientRoom.sensorData.room.humid).length-1)]?.value : patientRoom.sensorData.room.humid).toFixed(1);
            // const bloodOxygenH1R1 = (Object.keys(patientRoom.sensorData.body.blood_oxygen).length-1>0 & Object.keys(hospital.val().Rooms)[roomIndex]=="Room-1" & hospitalName=="Hospital-1"? (Object.values(patientRoom.sensorData.body.blood_oxygen)[(Object.keys(patientRoom.sensorData.body.blood_oxygen).length-1)]?.value || Object.values(patientRoom.sensorData.body.blood_oxygen)[50]?.Value)  : patientRoom.sensorData.body.blood_oxygen).toFixed(1);
            const bloodOxygen = (Object.keys(patientRoom.sensorData.body.blood_oxygen).length-1>0 ? (Object.values(patientRoom.sensorData.body.blood_oxygen)[(Object.keys(patientRoom.sensorData.body.blood_oxygen).length-1)]?.value || Object.values(patientRoom.sensorData.body.blood_oxygen)[(Object.keys(patientRoom.sensorData.body.blood_oxygen).length-1)]?.Value)  : patientRoom.sensorData.body.blood_oxygen).toFixed(1);
            const bloodPressureDiastolic = (Object.keys(patientRoom.sensorData.body.blood_pressure_diastolic).length-1>0 ? (Object.values(patientRoom.sensorData.body.blood_pressure_diastolic)[(Object.keys(patientRoom.sensorData.body.blood_pressure_diastolic).length-1)]?.value || Object.values(patientRoom.sensorData.body.blood_pressure_diastolic)[(Object.keys(patientRoom.sensorData.body.blood_pressure_diastolic).length-1)]?.Value) : patientRoom.sensorData.body.blood_pressure_diastolic).toFixed(1);
            const bloodPressureSystolic = (Object.keys(patientRoom.sensorData.body.blood_pressure_systolic).length-1>0 ? (Object.values(patientRoom.sensorData.body.blood_pressure_systolic)[(Object.keys(patientRoom.sensorData.body.blood_pressure_systolic).length-1)]?.value || Object.values(patientRoom.sensorData.body.blood_pressure_systolic)[(Object.keys(patientRoom.sensorData.body.blood_pressure_systolic).length-1)]?.Value) : patientRoom.sensorData.body.blood_pressure_systolic).toFixed(1);
            const bodyTemperature = (Object.keys(patientRoom.sensorData.body.body_temperature).length-1>0 ? (Object.values(patientRoom.sensorData.body.body_temperature)[(Object.keys(patientRoom.sensorData.body.body_temperature).length-1)]?.value || Object.values(patientRoom.sensorData.body.body_temperature)[(Object.keys(patientRoom.sensorData.body.body_temperature).length-1)]?.Value) : patientRoom.sensorData.body.body_temperature).toFixed(1);
            const heartRate = (Object.keys(patientRoom.sensorData.body.heart_rate).length-1>0 ? (Object.values(patientRoom.sensorData.body.heart_rate)[(Object.keys(patientRoom.sensorData.body.heart_rate).length-1)]?.value || Object.values(patientRoom.sensorData.body.heart_rate)[(Object.keys(patientRoom.sensorData.body.heart_rate).length-1)]?.Value) : patientRoom.sensorData.body.heart_rate).toFixed(1);
            array.push({name: patientRoom.info.patientName, roomNo:Object.keys(hospital.val().Rooms)[roomIndex], hospitalName, mq2, mq9, mq135, temp, humid, bloodOxygen, bloodPressureDiastolic, bloodPressureSystolic, bodyTemperature, heartRate});
          })
        })
        setLoading(false)
        setDetails(array);
        
        console.log(room4)
      })

      return ()=>{
        console.log("Cleanup");
        return rtd.off();
      }
    }, []);

    console.log("Details: ",details);

    return (
      <>
      {loading ? 
        <div style={{position:"absolute", bottom:"400px", left:"60vw"}}>
          <FadeLoader color={"#008db9"} loading={true} size={40}/>
        </div>:
        <MUIDataTable
        title={"All Patients Data"}
        data={details}
        columns={columns}
        options={options}
        />
      }
      </>
    )
}

export default CentralDashboard;
